import { render, staticRenderFns } from "./TableImg.vue?vue&type=template&id=c8315d34&scoped=true&"
import script from "./TableImg.vue?vue&type=script&lang=js&"
export * from "./TableImg.vue?vue&type=script&lang=js&"
import style0 from "./TableImg.vue?vue&type=style&index=0&id=c8315d34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8315d34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8315d34')) {
      api.createRecord('c8315d34', component.options)
    } else {
      api.reload('c8315d34', component.options)
    }
    module.hot.accept("./TableImg.vue?vue&type=template&id=c8315d34&scoped=true&", function () {
      api.rerender('c8315d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/TableImg.vue"
export default component.exports